import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { OccWishlistService, WishlistActions } from '@wishlist/data-access';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@Injectable()
export class WishlistEffects {
  loadWishlistEntryList$: Observable<
    WishlistActions.LoadWishlistEntryListSuccess | WishlistActions.LoadWishlistEntryListFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<WishlistActions.LoadWishlistEntryList>(WishlistActions.LOAD_WISHLIST_ENTRY_LIST),
      switchMap(() =>
        this.occWishlistService.getEntries().pipe(
          map((entries: WishlistEntry[]) => new WishlistActions.LoadWishlistEntryListSuccess(entries)),
          catchError((e) => of(new WishlistActions.LoadWishlistEntryListFail(e))),
        ),
      ),
    ),
  );

  addOrRemoveWishlistEntry$: Observable<
    | WishlistActions.AddWishlistEntrySuccess
    | WishlistActions.AddWishlistEntryFail
    | WishlistActions.RemoveWishlistEntrySuccess
    | WishlistActions.RemoveWishlistEntryFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<WishlistActions.AddWishlistEntry | WishlistActions.RemoveWishlistEntry>(
        WishlistActions.ADD_WISHLIST_ENTRY,
        WishlistActions.REMOVE_WISHLIST_ENTRY,
      ),
      // сделано, чтобы нельзя было запустить несколько одинаковых запросов к бэку на удаление или добавление товара в избранное
      distinctUntilChanged(
        (prev, curr) => prev.payload.productCode === curr.payload.productCode && prev.type === curr.type,
      ),
      switchMap((action) => {
        if (action.type === WishlistActions.ADD_WISHLIST_ENTRY) {
          return this.occWishlistService.addEntry(action.payload).pipe(
            map(() => new WishlistActions.AddWishlistEntrySuccess(action.payload)),
            catchError((e) => of(new WishlistActions.AddWishlistEntryFail(action.payload, e))),
          );
        } else {
          return this.occWishlistService.removeEntry(action.payload).pipe(
            map(() => new WishlistActions.RemoveWishlistEntrySuccess(action.payload)),
            catchError((e) => of(new WishlistActions.RemoveWishlistEntryFail(action.payload, e))),
          );
        }
      }),
    ),
  );

  resetWishlistEntryList$: Observable<WishlistActions.ResetWishlistEntryList> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      map(() => new WishlistActions.ResetWishlistEntryList()),
    ),
  );

  loadWishlistEntryListOnLogin$: Observable<WishlistActions.LoadWishlistEntryList> = createEffect(() =>
    this.actions$.pipe(
      ofType<AuthActions.Login>(AuthActions.LOGIN),
      map(() => new WishlistActions.LoadWishlistEntryList()),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly occWishlistService: OccWishlistService,
  ) {}
}
